import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'bootstrap'
import "bootstrap/dist/css/bootstrap.css";
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import VueElementLoading from 'vue-element-loading'
Vue.component('vue-element-loading', VueElementLoading)

import "@/assets/main.css";
import "@/assets/font-awesome/css/font-awesome.min.css";
import "@/assets/vue-select.css";

const moment = require('moment')
require('moment/locale/th')
Vue.use(require('vue-moment'), {moment})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
